module.exports = __webpack_public_path__ + "static/img/poster_imgb.9ef1f716.jpg";